export function openIntercomUpgrade(message: string) {
	if (typeof window === 'undefined' || !window.Intercom) return;
	window.Intercom('showNewMessage', message);
}

export const INTERCOM_UPGRADE_MESSAGES = {
	glazierChat: "I'd like to learn more about the Glazier AI assistant (Enterprise).",
	smartSchedule: "I'd like to learn more about Smart Schedule (Enterprise).",
	smartTakeoff: "I'd like to learn more about Smart Takeoff (Enterprise).",
	twoWayEmail: "I'd like to learn more about 2-way email (Enterprise).",
} as const;
